import makeStyles from '@mui/styles/makeStyles';

const DRAWER_WIDTH = 288;

export default makeStyles(theme => ({
    root: {
        display: 'flex',
		flexDirection: 'row',
        flexGrow: 1,
		alignItems: 'stretch',
		overflow: 'hidden',
		height: '100%',
		maxHeight: '100%',
    },
	welcomeRoot: {
        display: 'flex',
		flexDirection: 'row',
        flexGrow: 1,
		alignItems: 'stretch',
		overflow: 'hidden',
		height: '100%',
		maxHeight: '100%',
		backgroundColor: '#CCACDC'
    },
    appBar: {
		[theme.breakpoints.up('md')]: {
			transition: ({ drawerOpen }) => (
				theme.transitions.create(['padding'], {
					easing: theme.transitions.easing.easeOut,
					duration: theme.transitions.duration[drawerOpen ? 'enteringScreen' : 'leavingScreen'],
				})
			),

			paddingLeft: ({ drawerOpen }) => drawerOpen ? DRAWER_WIDTH : 0,
		},
    },
	appBarTitle: {
		marginRight: 'auto',
	},
    drawer: {
        flexShrink: 0,
    },
	drawerToolbar: {
		justifyContent: 'flex-end',
	},
    drawerPaper: {
        width: DRAWER_WIDTH,

    },
    drawerBackButton: {
        // alignSelf: 'flex-end',
    },
	contentBox: {
		flexGrow: 1,

		[theme.breakpoints.up('md')]: {
			transition: ({ drawerOpen }) => (
				theme.transitions.create('margin', {
					easing: theme.transitions.easing[drawerOpen ? 'easeOut' : 'sharp'],
					duration: theme.transitions.duration[drawerOpen ? 'enteringScreen' : 'leavingScreen'],
				})
			),

			marginLeft: ({ drawerOpen }) => drawerOpen ? DRAWER_WIDTH : 0,
        },
	},
    content: {
        paddingTop: theme.spacing(2),
        overflowX: 'visible',
    },
	innerSpacer: {
		...theme.mixins.toolbar,
		flexShrink: 0,
	},
}));